import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { CurrentUserService } from '@shared/services';

export const userGuard: CanActivateFn = async () => {
    const currentUserService = inject(CurrentUserService);
    const currentUser = await currentUserService.initializeCurrentUser();

    return !!currentUser;
};
